import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import journalLpo from './modules/journalLpo';

import lpoData from './modules/lpoData';
import selectedLpo from './modules/selectedLpo';
import actLpo from './modules/actLpo';
import taxInfo from './taxInfo';
import catalogs from './modules/catalogs';

import createLpo from './modules/createLpo';

import auth from './modules/auth';
import user from './modules/user';

import currentLpo from './modules/currentLpo';


import recount from './modules/recount';
import common from './modules/common';

export default new Vuex.Store({
	strict: true,

  modules: {
  	journalLpo,

    catalogs,
    taxInfo,

    lpoData,
    selectedLpo,
    actLpo,

    createLpo,

    auth,
    user,

    currentLpo,

    
    recount,
    common
  }
});